import {
  TyrianApp
} from './target/scala-3.1.1/timerboard-fastopt.js';

TyrianApp.launch("myapp");
